<template>
  <div>
    <el-dialog
      title="Dodaj nowy widget"
      width="80vw"
      :visible.sync="dialogFormVisible"
      append-to-body
    >
      <el-row
        :gutter="12"
        v-for="(widgets, group) in groupedWidgets"
        :key="group"
      >
        <el-col :span="24">
          <h3>{{ group }}</h3>
        </el-col>
        <el-col :span="8" v-for="type in widgets" :key="type.polymorphic_ctype">
          <el-card
            shadow="hover"
            :key="type.polymorphic_ctype"
            class="type"
            @click.native="addWidget(type)"
          >
            <img class="thumbnail" :src="getImageForType(type)" alt="" />
            {{ type.label }}
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelForm()">Anuluj</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { groupBy, orderBy } from 'lodash'

export default {
  props: ['bus', 'hiddenWidgets'],
  data() {
    return {
      dialogFormVisible: false
    }
  },
  mounted() {
    this.bus.$on('openAddWidgetDialog', this.openDialog)
  },
  computed: {
    filteredWidgetTypes() {
      let widgets = this.$store.state.widgetTypes
      if (this.hiddenWidgets) {
        widgets = widgets.filter(
          obj => !this.hiddenWidgets.includes(obj.resourcetype)
        )
      }
      return widgets
    },
    groupedWidgets() {
      const sortedTypes = orderBy(this.filteredWidgetTypes, ['group'], ['desc'])
      return groupBy(sortedTypes, 'group')
    }
  },
  methods: {
    openDialog() {
      this.dialogFormVisible = true
    },
    cancelForm() {
      this.dialogFormVisible = false
      this.$emit('cancel')
    },
    addWidget(type) {
      this.$emit('addWidget', type)
      this.dialogFormVisible = false
    },
    getImageForType(type) {
      return `/widgets/icons/${type.resourcetype}.png`
    }
  }
}
</script>
<style lang="scss" scoped>
.type {
  cursor: pointer;
}

.el-card {
  margin-bottom: 18px;
}

.thumbnail {
  height: 100px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  display: block;
  margin-bottom: 15px;
}
</style>
